// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tmrc0","col":"styles_col__1y44B"};